// extracted by mini-css-extract-plugin
export default {"htmlContent":"ThemedHtml_htmlContent__aM5eQ"};